<template>
<div class="homework">
  <h3>Домашнее задание</h3>

  <div class="header-menu">
    <button 
      class="header-menu__btn header-menu__btn--tab"
      @click="currentTab = 'HomeworkTab'; is_dynamical = false"
      :class="{active: currentTab === 'HomeworkTab' && !is_dynamical}"
    >
      Задания
    </button>
    <!-- <button 
      class="header-menu__btn header-menu__btn--tab"
      @click="currentTab = 'HomeworkTab'; is_dynamical = true"
      :class="{ active: currentTab === 'HomeworkTab' && is_dynamical }"
    >
      Динамические
    </button> -->
    <button 
      class="header-menu__btn header-menu__btn--tab"
      @click="currentTab = 'TemplatesTab'"
      :class="{active: currentTab === 'TemplatesTab'}"
    >
      Шаблоны
    </button>
  </div>

  <component 
    :is="currentTab"
    :classItem="classItem"
    :classLessons="classLessons"
    :is_dynamical="is_dynamical"

    @add-lesson-block="openPopup('AddClassLessonBlock', null)"
  ></component>

  <Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
    <template v-slot:content>
      <component 
        :is="popupContent" 
        :data="popupData"
        :classItem="classItem" 

        @close-popup="popupIsOpened = false"
        @add-lesson-block="addLessonBlock"      
      ></component>
    </template>
  </Popup>
</div>
</template>

<script>
import AddClassLessonBlock from './AddClassLessonBlock.vue'
import HomeworkTab from './HomeworkTab.vue'
import TemplatesTab from './TemplatesTab.vue'

import { mapState } from 'vuex'
import { popup_mix } from '../../../../mixins/popup_mix'

export default {
  name: "homework-list",
  inject: ['http'],
  mixins: [ popup_mix ],
  props: ['classItem'],
  components: {
    AddClassLessonBlock,
    TemplatesTab,
    HomeworkTab
  },
  data() {
    return {
      classLessons: [],
      currentTab: 'HomeworkTab',
      is_dynamical: false,
    }
  },  
  computed: {
    ...mapState({
      user: state => state.user,
      homework: state => state.teacher.teacherHomework
    })
  },
  methods: { 
    addLessonBlock(data) {
      data.is_dynamical = this.is_dynamical ? true : false
      this.classLessons.unshift(data)
    },  
    getClassLessons() {
      this.http.post('onGetClassLessons', { class_id: this.classItem.id }).then(res => {
        this.classLessons = res.data
        console.log(this.classLessons)
      })
    }    
  },
  created() {
    this.getClassLessons()
  }
}
</script>

<style lang="scss" scoped>
.homework {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  & h3 {
    margin: 0;
  }
}

</style>
